import { render, staticRenderFns } from "./FormFlights.vue?vue&type=template&id=488c7845&"
import script from "./FormFlights.vue?vue&type=script&lang=js&"
export * from "./FormFlights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports